export default __webpack_public_path__ + "static/media/0076.370185fe.png";